/**
 * @generated SignedSource<<58641336454e10d70103431335415ad7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Device = "MOBILE" | "TABLET" | "PC" | "%future added value";
export type OrderDirection = "ASC" | "DESC" | "%future added value";
export type PageKind = "LANDING" | "FORM" | "CONFIRM" | "THANKS" | "%future added value";
export type SiteReportOrderField = "UNIQUE_USER" | "CONVERSION" | "CVR" | "LP_DROP_RATE" | "LP_SCROLL_RATE" | "LP_AVERAGE_STAY_TIME" | "FORM_DROP_RATE" | "MOBILE_RATE" | "TABLET_RATE" | "PC_RATE" | "DEVICE" | "PAGE_VIEW_USER" | "USE_CHATBOT_USER" | "USE_CHATBOT_USER_RATE" | "CHATBOT_CVR" | "POPUP_READY_USER" | "CLOSE_POPUP" | "CLICK_POPUP" | "POPUP_CLICK_CONVERSION" | "POPUP_IMPRESSION_CONVERSION" | "POPUP_READY_CONVERSION" | "POPUP_DROP" | "POPUP_DROP_CONVERSION" | "POPUP_CONVERSION" | "POPUP_CTR" | "POPUP_CVR" | "POPUP_CLICK_CVR" | "POPUP_IMPRESSION_CVR" | "POPUP_DROP_CVR" | "%future added value";
export type ReportInput = {
  startDate?: string | null;
  endDate?: string | null;
  orderBy?: SiteReportOrder | null;
  device?: Device | null;
  sourceId?: string | null;
  funnelIds?: ReadonlyArray<string> | null;
  pageKind?: PageKind | null;
};
export type SiteReportOrder = {
  field: SiteReportOrderField;
  direction: OrderDirection;
};
export type DailyReportContainer_Query$variables = {
  input: ReportInput;
  slug: string;
};
export type DailyReportContainer_QueryVariables = DailyReportContainer_Query$variables;
export type DailyReportContainer_Query$data = {
  readonly site: {
    readonly " $fragmentSpreads": FragmentRefs<"DailyReportTable_site" | "DailyReportGraph_site">;
  };
};
export type DailyReportContainer_QueryResponse = DailyReportContainer_Query$data;
export type DailyReportContainer_Query = {
  variables: DailyReportContainer_QueryVariables;
  response: DailyReportContainer_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DailyReportContainer_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Site",
        "kind": "LinkedField",
        "name": "site",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DailyReportTable_site"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DailyReportGraph_site"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DailyReportContainer_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Site",
        "kind": "LinkedField",
        "name": "site",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
              }
            ],
            "kind": "ScalarField",
            "name": "reportDaily",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6b9c6804343938b43cf21631f1605680",
    "id": null,
    "metadata": {},
    "name": "DailyReportContainer_Query",
    "operationKind": "query",
    "text": "query DailyReportContainer_Query(\n  $input: ReportInput!\n  $slug: String!\n) {\n  site(slug: $slug) {\n    ...DailyReportTable_site\n    ...DailyReportGraph_site\n    id\n  }\n}\n\nfragment DailyReportGraph_site on Site {\n  reportDaily(input: $input)\n}\n\nfragment DailyReportTable_site on Site {\n  reportDaily(input: $input)\n}\n"
  }
};
})();

(node as any).hash = "3ad10a0f284a06216498935893618379";

export default node;
